module.exports = __webpack_public_path__ + "8b8cff04aa936a5c9f10afd16c56d1ae.jpg";